
		(async () => {
		  
	{
	  const mod = await import("/src/lib/components/audio-player/AudioPlayer.svelte");
	  const C = mod.default;
	  const Component = (C && C.element) ? C.element : C;
	  const TAG = "audio-player";
  
	  if (!customElements.get(TAG)) {
		customElements.define(TAG, Component);
	  }
	}
	
		})();
	  